import React from 'react';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import {
	Col,
	Row,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	FormGroup,
	Label,
	ModalFooter,
} from 'reactstrap';
import IntlMessage from "../../helpers/intlMessage";



function ConfirmacaoComponent(props) {
	const {messages} = props.intl;
	const detalhes = useSelector((state) => state.commonReducer.detalhes);
	const etapaAtual = useSelector((state) => state.commonReducer.etapa);
	const etapasRealizadas = SelectionarEtapasRealizadas(
		detalhes.etapas,
		etapaAtual
	);

	function SelectionarEtapasRealizadas(etapas, etapaAtual) {
		// eslint-disable-next-line array-callback-return
	
		const etapasRealizadas = etapas.filter((etapa) => {
			if (etapa.status === 'realizado') return etapa;
		});
	
		const indiceEtapaAtual = etapasRealizadas.findIndex(
			(item) => item.etapa === etapaAtual.etapa
		);
	
		etapasRealizadas.splice(0, indiceEtapaAtual);
	
		return etapasRealizadas;
	}

	return (
		<Modal isOpen={props.isOpen} toggle={props.toggle}>
			<ModalHeader toggle={props.toggle}>
				{props.title ? props.title : <IntlMessage id = "dashboards.examDetail.cancelStep.confirm"/>}
			</ModalHeader>
			<ModalBody>
				<Row>
					<Col>
						<FormGroup className="justificativa-cancelar">
							<Label>
								<IntlMessage id = "dashboards.examDetail.cancelStep.confirmCancel"/>
							</Label>
							<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
								{etapasRealizadas.map((etapa) => (
									<li key={etapa}>
										<strong>{etapa.etapa}</strong>
									</li>
								))}
							</ul>
						</FormGroup>
					</Col>
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button onClick={props.toggle} color="secondary">
					<IntlMessage id = "dashboards.examDetails.cancel"/>
				</Button>
				<Button onClick={props.shoModalJustificativa} color="primary">
					{props.confirmTextLabel
						? props.confirmTextLabel
						: messages["dashboards.examDetail.cancelStep.stepCancel"]}
				</Button>
			</ModalFooter>
		</Modal>
	);
}

export default injectIntl(ConfirmacaoComponent);



// WEBPACK FOOTER //
// ./src/componentes/cancelamento/confirmacao.component.jsx